import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import { BcCommon } from '@/plugins/common';
import { EBcDeviceType } from '@/classes/BcEnums';
export class BcNRDialogForm {
    constructor(op) {
        this.device = '';
        this.recorder = '';
        this.total = null;
        this.success = null;
        this.fails = null;
        this.bottles = null;
        this.dspTime = null;
        this.noErrorRunTime = null;
        this.malfunctions = [];
        this.remark = '';
        const that = this;
        if (op) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class BcNRDialog {
    constructor(op) {
        this.title = '';
        this.text = '';
        this.visible = false;
        this.loading = false;
        this.formValid = false;
        this.noDispense = true;
        this.form = new BcNRDialogForm();
        this.displaySubtitle = false;
        this.menuDate = {
            visible: false
        };
        const that = this;
        if (op) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let BcCreateRecord = class BcCreateRecord extends Vue {
    constructor() {
        super();
        this.hospitals = [];
        this.devices = [];
        this.dialogTips = {
            text: '',
            visible: false,
            action: () => { }
        };
        this.dlgMobileNewRecord = new CBcDialog(new CBcDialogForm());
        this.dlgDspRecordMult = new CBcDialog(new CBcDialogForm());
        this.formFields = {
            isShowBottles: true,
            isShowDspTime: true,
            isShowNoErrorRunTime: true,
            dateHint: '配置日期',
            totalHint: '配置总数',
            successHint: '配置成功数',
            failsHint: '配置失败数'
        }; // 表单提示信息配置，默认显示台式机的
        const that = this;
        // that.dlgMobileNewRecord = new CBcDialog(new CBcDialogForm())
    }
    changed(v) {
        const that = this;
        that.$emit('input', v);
    }
    onDialogNoDispenseChanged(v) {
        const that = this;
        if (v) {
            if (that.dialog.form.malfunctions.length < 1)
                that.dialog.form.malfunctions.push({ description: '', status: '待处理' });
        }
    }
    onDialogHospitalChanged(v, o) {
        const that = this;
        if (v === o)
            return;
        that.dialog.form.device = null;
    }
    onDialogMultiDspHospitalChanged(v, o) {
        const that = this;
        if (v === o)
            return;
        that.dlgDspRecordMult.form.device = null;
    }
    async mounted() {
        const that = this;
        await that.getHospitals();
        // await that.getDevice()
    }
    openDialogTips(text, title, action) {
        const that = this;
        that.dialogTips.title = title || '操作提示';
        that.dialogTips.text = text;
        that.dialogTips.visible = true;
        that.dialogTips.action = action;
    }
    dialogTipsAccepted() {
        const that = this;
        if (/function/i.test(typeof that.dialogTips.action()))
            that.dialogTips.action();
        that.dialogTips.visible = false;
    }
    get isFormValid() {
        const that = this;
        const deviceOk = Number(that.dialog.form.device && that.dialog.form.device.id || 0) > 0;
        if (that.dialog.noDispense) {
            return that.dialog.form.malfunctions.filter((v) => v.description).length > 0 && deviceOk;
        }
        else {
            return (Number(that.dialog.form.total) > 0 && ((Number(that.dialog.form.success) > 0) || (Number(that.dialog.form.fails) > 0))) && deviceOk;
        }
    }
    get isFormMultiDspValid() {
        const that = this;
        const deviceOk = Number(that.dlgDspRecordMult.form.device && that.dlgDspRecordMult.form.device.id || 0) > 0;
        const rs = that.dlgDspRecordMult.form.records || [];
        const hasNotOkItem = rs.filter((v) => ((!v.date) || (Number(v.total) !== parseFloat(v.total))));
        return !hasNotOkItem.length && deviceOk;
    }
    checkAllowMultiDspRecordDates(val) {
        const that = this;
        const recs = that.dlgDspRecordMult.form.records || [];
        return !(recs.find((iv) => iv.date === val));
    }
    openCreateRecordType() {
        const that = this;
        that.dlgMobileNewRecord.title = '请选择新增记录类型';
        that.dlgMobileNewRecord.visible = true;
    }
    async createRecord(dev, hos) {
        const that = this;
        that.dlgMobileNewRecord.visible = false;
        // 表单录入字段结构
        if (dev) {
            that.deviceOnChange(dev);
        }
        try {
            that.dialog.noDispense = false;
            that.dialog.displaySubtitle = dev && hos;
            that.dialog.form = {
                userId: that.userInfo && that.userInfo.id,
                recorder: that.userInfo && that.userInfo.name,
                hospital: hos instanceof MouseEvent ? null : hos,
                device: dev instanceof MouseEvent ? null : dev,
                date: Vue.filter('dateFormat')(new Date(), 'yyyy-MM-dd'),
                malfunctions: [{ description: '', status: '待处理' }] // 故障记录默认添加一条空，提交时判断是否有内容，无内容删除；
            };
            setTimeout(() => {
                that.dialog.form.device = dev instanceof MouseEvent ? null : dev;
            });
            that.dialog.title = '新增记录';
            that.dialog.text = '';
            that.dialog.visible = true;
        }
        catch (e) {
            that.snackbar.error('新增记录功能出错，' + e.info || e.errorInfo || e.result || e.error || e.toString());
        }
    }
    async createDspMultiRecord(dev, hos) {
        const that = this;
        try {
            that.dlgMobileNewRecord.visible = false;
            that.dlgDspRecordMult.noDispense = false;
            that.dlgDspRecordMult.displaySubtitle = dev && hos;
            that.dlgDspRecordMult['menuDate'] = {
                visible: false
            };
            that.dlgDspRecordMult.form = {
                userId: that.userInfo && that.userInfo.id,
                recorder: that.userInfo && that.userInfo.name,
                hospital: hos instanceof MouseEvent ? null : hos,
                device: dev instanceof MouseEvent ? null : dev,
                date: Vue.filter('dateFormat')(new Date(), 'yyyy-MM-dd'),
                records: [] // 故障记录默认添加一条空，提交时判断是否有内容，无内容删除；
            };
            that.dlgDspRecordMult.title = '批量新增设备记录';
            that.dlgDspRecordMult.text = '';
            that.dlgDspRecordMult.visible = true;
        }
        catch (e) {
            that.snackbar.error('新增记录功能出错，' + e.info || e.errorInfo || e.result || e.error || e.toString());
        }
    }
    removeMultiDspRecord(item) {
        const that = this;
        const realIdx = that.dlgDspRecordMult.form.records.map((v) => v.itemIdx).indexOf(item.itemIdx);
        if (item.total) {
            that.openDialogTips('当前要删除的条目内容不为空，请确定是否执行删除操作', '', () => { that.dlgDspRecordMult.form.records.splice(realIdx, 1); });
        }
        else {
            that.dlgDspRecordMult.form.records.splice(realIdx, 1);
        }
    }
    async saveNewMultiDspRecord() {
        const that = this;
        let saveMsg = '';
        let success = false;
        try {
            const form = JSON.parse(JSON.stringify(that.dlgDspRecordMult.form));
            if (form && form.records && form.records.length > 0) {
                // 根据条件清理字段
                form.records.forEach((v) => {
                    // 以下字段只用作配药记录，其他情况就清空
                    if (!that.formFields.isShowBottles) {
                        v.bottles = null;
                    }
                    if (!that.formFields.isShowDspTime) {
                        v.dspTime = null;
                    }
                    if (!that.formFields.isShowNoErrorRunTime) {
                        v.noErrorRunTime = null;
                    }
                });
            }
            const body = {
                ...form,
                type: 'multiDsp',
                deviceId: form.device && form.device.deviceId,
                deviceNo: form.device && form.device.deviceNo,
                hospitalId: form.hospital && form.hospital.id,
                list: [...form.records]
            };
            delete body['records'];
            const rst = await that.axios.post('/api/recipels/record', body);
            const exists = rst && rst.data && rst['data']['exists'] || [];
            if (exists.length) {
                // eslint-disable-next-line eqeqeq
                that.dlgDspRecordMult.form.records = [...that.dlgDspRecordMult.form.records.filter((v) => exists.find((fv) => fv.date == v.date))];
                that.snackbar.warn(rst && rst.data && rst.data.result || '新增记录成功,过程出现错误');
            }
            else {
                that.snackbar.success('新增记录成功');
                that.dlgDspRecordMult.visible = false;
                that.dlgDspRecordMult.form = {};
            }
            success = true;
        }
        catch (e) {
            console.log('error of save new Record:', e);
            saveMsg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error('新增记录失败，' + saveMsg);
        }
        that.$emit('saved', !success, saveMsg);
    }
    async saveNewRecord() {
        const that = this;
        let saveMsg = '';
        let success = false;
        try {
            if (that.dialog.noDispense) {
                that.dialog.form.total = null;
                that.dialog.form.success = null;
                that.dialog.form.fails = null;
                that.dialog.form.bottles = null;
                that.dialog.form.dspTime = null;
                that.dialog.form.noErrorRunTime = null;
            }
            // 以下字段只用作配药记录，其他情况就清空
            if (!that.formFields.isShowBottles) {
                that.dialog.form.bottles = null;
            }
            if (!that.formFields.isShowDspTime) {
                that.dialog.form.dspTime = null;
            }
            if (!that.formFields.isShowNoErrorRunTime) {
                that.dialog.form.noErrorRunTime = null;
            }
            const body = JSON.parse(JSON.stringify(that.dialog.form));
            body['malfunctions'] = body.malfunctions && body.malfunctions.filter((v) => v.description !== null && v.description !== undefined && String(v.description).length);
            body['deviceId'] = body.device && body.device.deviceId; // 此处的device为hospital与device的关联表，所以实际设备ID为deviceId
            body['deviceNo'] = body.device && body.device.deviceNo;
            body['hospitalId'] = body.hospital && body.hospital.id;
            // delete body['device']
            // delete body['hospital']
            saveMsg = await that.axios.post('/api/recipels/record', body);
            that.dialog.visible = false;
            that.snackbar.success('新增记录成功');
            that.form = {};
            success = true;
        }
        catch (e) {
            console.log('error of save new Record:', e);
            saveMsg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error('新增记录失败，' + saveMsg);
        }
        that.$emit('saved', !success, saveMsg);
    }
    async getHospitals() {
        const that = this;
        try {
            const res = (await that.axios.get('/api/hospital?isSummaryDetail=false'));
            that.hospitals = res && res.data && res.data.result || [];
        }
        catch (e) {
            console.log('error of get hosp list in createRecord:', e);
            that.snackbar.error('医院信息获取失败,' + (e && (e.errorInfo || e.result || e.toString())));
        }
    }
    async getDevice() {
        const that = this;
        try {
            const res = await that.axios.get('/api/device');
            that.devices = res && res.data && res.data.result || [];
        }
        catch (e) {
            console.log('error of get device list in createRecord:', e);
            that.snackbar.error('设备信息获取失败,' + (e && (e.errorInfo || e.result || e.toString())));
        }
    }
    // 监听设备选择
    deviceOnChange(data) {
        // 这里根据设备类型获取设备类型
        const deviceType = BcCommon.getDeviceCategory(data.type, data.mode);
        this.formFields.deviceType = deviceType;
        this.formFields.isShowBottles = false;
        this.formFields.isShowDspTime = false;
        this.formFields.isShowNoErrorRunTime = false;
        // 获取后根据设备类型展示设备记录字段描述
        switch (deviceType) {
            case EBcDeviceType.Ampul:
            case EBcDeviceType.Auto:
            case EBcDeviceType.Xilin:
            case EBcDeviceType.Liquid:
            case EBcDeviceType.Other:
            case EBcDeviceType.PreDissolve:
                if (deviceType == EBcDeviceType.Ampul || deviceType == EBcDeviceType.Xilin || deviceType == EBcDeviceType.Auto) {
                    this.formFields.isShowBottles = true;
                    this.formFields.isShowDspTime = true;
                    this.formFields.isShowNoErrorRunTime = true;
                }
                this.formFields.dateHint = '配置日期';
                this.formFields.totalHint = '配置总数';
                this.formFields.successHint = '配置成功数';
                this.formFields.failsHint = '配置失败数';
                break;
            case EBcDeviceType.BreathTrain:
                this.formFields.dateHint = '训练日期';
                this.formFields.totalHint = '训练总人数';
                this.formFields.successHint = '达标人数';
                this.formFields.failsHint = '未达标人数';
                this.formFields.isShowBottles = false;
                break;
            case EBcDeviceType.EndoscopeArk:
                this.formFields.dateHint = '存储日期';
                this.formFields.totalHint = '存取总数';
                this.formFields.successHint = '存入次数';
                this.formFields.failsHint = '取出次数';
                this.formFields.isShowBottles = false;
                break;
            case EBcDeviceType.CleaningMachine:
                this.formFields.dateHint = '清洗日期';
                this.formFields.totalHint = '清洗总数';
                this.formFields.successHint = '清洗成功数';
                this.formFields.failsHint = '清洗失败数';
                this.formFields.isShowBottles = false;
                break;
        }
    }
    // 添加记录按钮事件
    async addRecord() {
        const that = this;
        if (!that.dlgDspRecordMult.form.hospital) {
            that.snackbar.warn('请先选择医院后添加记录！');
            return;
        }
        if (!that.dlgDspRecordMult.form.device) {
            that.snackbar.warn('请先选择设备后添加记录！');
            return;
        }
        that.dlgDspRecordMult.form.records.push({ date: '', total: '', success: '', fails: '', bottles: '', dspTime: '', noErrorRunTime: '', menuDate: false, menuEvents: [], remark: '', itemIdx: (that.dlgDspRecordMult.form.records || []).length + 1 });
    }
    ;
};
__decorate([
    Getter
], BcCreateRecord.prototype, "userInfo", void 0);
__decorate([
    Prop()
], BcCreateRecord.prototype, "snackbar", void 0);
__decorate([
    Model('value')
], BcCreateRecord.prototype, "dialog", void 0);
__decorate([
    Watch('dialog.noDispense')
], BcCreateRecord.prototype, "onDialogNoDispenseChanged", null);
__decorate([
    Watch('dialog.form.hospital')
], BcCreateRecord.prototype, "onDialogHospitalChanged", null);
__decorate([
    Watch('dlgDspRecordMult.form.hospital')
], BcCreateRecord.prototype, "onDialogMultiDspHospitalChanged", null);
BcCreateRecord = __decorate([
    Component({
        name: 'BcCreateRecord',
        components: {
            BcDialog,
        },
    })
], BcCreateRecord);
export default BcCreateRecord;
